<template>
  <div class="flex min-h-screen items-center justify-center bg-white px-6">
    <div class="max-w-xl text-center">
      <!-- Loading Spinner -->
      <div
        class="mx-auto h-20 w-20 animate-spin rounded-full border-4 border-orange-200 border-t-orange-500"
      ></div>

      <h1 class="mt-8 text-4xl font-bold text-secondary">
        Verifying Your Payment
      </h1>

      <p class="mt-4 text-lg text-zinc-600">
        Please wait while we securely confirm your payment.
      </p>

      <p class="mt-6 leading-8 text-zinc-500">
        This usually takes only a few seconds. Please do not refresh or close
        this page until the verification is complete.
      </p>

      <div class="mt-10 rounded-xl bg-orange-50 p-5 text-left">
        <h2 class="font-semibold text-orange-600">What's happening?</h2>

        <ul class="mt-3 space-y-2 text-sm text-zinc-700">
          <li>✓ Checking your payment transaction</li>
          <li>✓ Confirming payment with our payment gateway</li>
          <li>✓ Processing your HMO renewal</li>
          <li>✓ Preparing your confirmation receipt</li>
        </ul>
      </div>

      <p class="mt-8 text-sm text-zinc-400">
        Please keep this page open while we complete the verification.
      </p>
    </div>
  </div>
</template>

<script>
import { inject, onMounted, onUnmounted } from "vue";

export default {
  name: "PaymentConfirmation",

  setup() {
    const axios = inject("$axios");
    const store = inject("$store");

    let interval = null;
    let timeout = null;

    const checkPaymentStatus = async () => {
      try {
        const { data } = await axios.get(
          `/meta/xendit/payment/status/${store.state.planDetails.xendit_id}`
        );

        console.log("Payment Status:", data);

        if (data.payment_status === "PAID") {
          clearInterval(interval);

          return window.location.replace(
            `/payment/center/payment-confirmation/success/${store.state.planDetails.xendit_id}`
          );
        }

        if (data.payment_status === "EXPIRED") {
          clearInterval(interval);

          return window.location.replace(
            "/payment/center/payment-confirmation/expired"
          );
        }

        if (data.payment_status === "FAILED") {
          clearInterval(interval);

          return window.location.replace(
            "/payment/center/payment-confirmation/failed"
          );
        }

        // PENDING - continue polling
      } catch (error) {
        console.error("Payment Status Error:", error);
      }
    };

    onMounted(() => {
      // Wait 5 seconds before first check
      timeout = setTimeout(() => {
        checkPaymentStatus();

        // Check every 10 seconds thereafter
        interval = setInterval(checkPaymentStatus, 10000);
      }, 5000);
    });

    onUnmounted(() => {
      if (timeout) {
        clearTimeout(timeout);
      }

      if (interval) {
        clearInterval(interval);
      }
    });

    return {};
  },
};
</script>
